const accessorKeyHeaderRecord: Record<string, string> = {
    "Id": "ID",
    "phoneNumber": "Phone Number",
    "createdAt": "Created At",
    "bidderGroup_name": "Group"
};

export default accessorKeyHeaderRecord;